import * as actualiteStyles from "../../../styles/widgets/actualite.module.scss";

import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {altNN, getDate, getDisplayLang} from "../../../utils/parsing";

import PolyLink from "../PolyLink";
import React from "react";
import clsx from "clsx";

const Actualite = ({
    start_date, title, description, image, url, eventLanguage, locale, target,
}) => {
    let displayLang = getDisplayLang(eventLanguage, locale);
    let parsedDate = getDate(start_date, ".");
    return (<PolyLink style={{display: "block"}} url={url} tabIndex="0" target={target}>
        <div
            className={clsx(actualiteStyles.bloc, actualiteStyles.hover)}
        >
            <div className={actualiteStyles.blocImage}>
                {image && getImage(image.imageFile) && (<GatsbyImage
                    image={getImage(image.imageFile)}
                    style={{height: "100%", width: "100%"}}
                    alt={altNN("")}
                ></GatsbyImage>)}
            </div>
            <div
                className={actualiteStyles.innerBloc}
            >
                <div
                    className={actualiteStyles.contentActualite}
                >
                    {parsedDate && (<div className={actualiteStyles.containerDate}>
                        <div className={actualiteStyles.dateBloc}>
                            <p
                                className={actualiteStyles.dateLabel}
                            >
                                {parsedDate}
                            </p>
                        </div>
                    </div>)}

                    <div className={actualiteStyles.margin}>
                        <p
                            className={clsx(actualiteStyles.h3Title, actualiteStyles.hovered, actualiteStyles.title)}
                            lang={displayLang}
                        >
                            {title}
                        </p>
                        <p
                            style={{height: "fit-content"}}
                            className={clsx(actualiteStyles.nbLines, actualiteStyles.subTitle)}
                            lang={displayLang}
                        >
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </PolyLink>);
};

export default Actualite;
